import { types } from "@vilocnv/allsetra-core";
import { ObjectLocationReportedEventDto } from "../dtos/object-location-reported-event.dto";

export function mapObjectLocationReportedEventToObject(
  objectLocationEventData: ObjectLocationReportedEventDto | undefined,
  object: types.IObject | undefined
): types.IObject | undefined {
  if (!objectLocationEventData || !object) return;

  const newObject: types.IObject = {
    ...object,
    location: {
      ...object.location,
      ...(objectLocationEventData.latitude !== undefined && {
        latitude: objectLocationEventData.latitude - 0.00001
      }),
      ...(objectLocationEventData.longitude !== undefined && {
        longitude: objectLocationEventData.longitude
      }),
      ...(objectLocationEventData.accuracy !== undefined && {
        accuracy: objectLocationEventData.accuracy
      }),
      ...(objectLocationEventData.altitude !== undefined && {
        altitude: objectLocationEventData.altitude
      }),
      ...(objectLocationEventData.resolvedAddress !== undefined && {
        resolvedAddress: objectLocationEventData.resolvedAddress
      }),
      ...(objectLocationEventData.locationDate !== undefined && {
        date: objectLocationEventData.locationDate
      })
    },
    ...(objectLocationEventData.direction !== undefined && {
      direction: objectLocationEventData.direction
    }),
    ...(objectLocationEventData.lastReportedDirection !== undefined && {
      lastReportedDirection: objectLocationEventData.lastReportedDirection
    })
  };

  return newObject;
}
